
























import Vue from "vue";
import { mapGetters } from "vuex";
import { functions } from "@/plugins/firebase";
import { User } from "@/store/types";

export default Vue.extend({
  name: "AdminUsers",
  data: () => ({
    users: []
  }),

  mounted: async function() {
    const result = await functions.httpsCallable("listUsers")({
      maxResults: 20,
      pageToken: ""
    });
    this.users = result.data.users;
  },
  computed: {
    ...mapGetters("users", ["fullName", "isAuthenticated", "avatarUrl"]),
    email() {
      return this.$store.state.users.user.email;
    }
  },
  methods: {
    goToUser(user: User) {
      this.$router.push({
        name: "AdminUser",
        params: {
          userUid: user.uid
        }
      });
    }
  }
});
